var _path, _g, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWvPivotSelector = function SvgWvPivotSelector(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 101,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.277 88.71V11.29",
    stroke: "#6899B0",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeDasharray: "2 2"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#wv-pivot-selector_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.022 83.548c.136-3.513-.436-12.073-1.034-16.983C32.35 61.318 23.89 11.59 17.24 11.59c-6.65 0-15.223 48.858-15.967 54.976C.723 71.09.395 76.88.405 81.935c.01 5.057.037 6.775 16.872 6.775 16.836 0 16.61-1.649 16.745-5.162Z",
    fill: "#6899B0",
    fillOpacity: 0.2
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.022 83.548c.136-3.513-.436-12.073-1.034-16.983C32.35 61.318 23.89 11.59 17.24 11.59c-6.65 0-15.223 48.858-15.967 54.976C.723 71.09.395 76.88.405 81.935c.01 5.057.037 6.775 16.872 6.775 16.836 0 16.61-1.649 16.745-5.162Z",
    stroke: "#6899B0",
    strokeWidth: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.748 66.724c-1.122-4.912-5.789-11.935-15.296-12.169-9.507-.234-14.504 7.623-16.168 13.327",
    stroke: "#6899B0",
    strokeWidth: 0.5,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "wv-pivot-selector_svg__a",
    x: -2.996,
    y: 10.189,
    width: 37.438,
    height: 78.921,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -3,
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.407843 0 0 0 0 0.6 0 0 0 0 0.690196 0 0 0 0.7 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "shape",
    result: "effect1_innerShadow_7236_3903"
  })))));
};
export default SvgWvPivotSelector;